import "./IconArrowLink.scss";

interface IconProps {
  iconColor?: "black" | "white" | "gray" | "blue";
  weight?: "regular" | "medium" | "thin";
}

export const IconArrowLink = ({ iconColor = "black", weight = "regular" }: IconProps) => {
  return <span className={`icon-arrow-link icon-arrow-link--${iconColor} icon-arrow-link--${weight}`} />;
};
